import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { IUserLoginRequest } from "../../models/IUserLoginRequest";
import { NotificationsToastService } from "../../../../shared/services/Notifications-Toast.service";
import { MatDialog } from "@angular/material/dialog";
import { SendRecoveryPasswordMailRequest } from "../../models/SendRecoveryPasswordMailRequest.model";
import { SendRecoveryPasswordDialogComponent } from "../../dialog/send-recovery-password-dialog/send-recovery-password-dialog.component";
import { MediaMatcher } from "@angular/cdk/layout";
import { AuthService } from "../../services/Auth.service";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";

import { environment } from "src/environments/environment";

@Component({
  selector: "login",
  templateUrl: "./loginPage.component.html",
  styleUrls: ["./loginPage.component.css"],
})
export class LoginPageComponent implements OnInit {
  formLogin: FormGroup;
  public isLoading: boolean = false;
  loginInvalid: boolean;
  resp: boolean;
  hidePassword: boolean = true;
  private config: {version: string}; 

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  subscription_Login: Subscription;
  subscription_GetDataCitronella: Subscription;
  subscription_GetClients: Subscription;
  suscription_checkAuth: Subscription;
  recoveryPasswordRequest = {} as SendRecoveryPasswordMailRequest;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private encriptionService: EncriptionService,
    private notificationsToastService: NotificationsToastService,
    private dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
    private localStorageService: LocalStorageService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 780px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.formLogin = formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });

    
  }

  ngOnInit(): void {
    this.config = require('src/assets/config.json'); 
      this.localStorageService.setVersion(this.config.version);

    // this.isLoggedIn();
    this.authService.clearStorage();
  }

  ngOnDestroy() {
    if (this.subscription_Login) this.subscription_Login.unsubscribe();
    if (this.subscription_GetDataCitronella) this.subscription_GetDataCitronella.unsubscribe();
    if (this.subscription_GetClients) this.subscription_GetClients.unsubscribe();
    if (this.suscription_checkAuth) this.suscription_checkAuth.unsubscribe();
  }

  Login() {
    this.isLoading= true;
    const usuarioLogin: IUserLoginRequest = {
      email: this.formLogin.value.email,
      password: this.formLogin.value.password,
    };
    this.isLoading= true;
    this.loginInvalid = false;
    this.subscription_Login = this.authService.Login(usuarioLogin).subscribe(
      (res) => {
        if (res.isSuccess == true) {
          const token = res.result.token;
          this.localStorageService.setUserName(res.result.userName);
          if (token) {
            if(!environment.production) console.log("**********LOGIN COMPLETE*******");
            this.localStorageService.setToken(token);
            this.localStorageService.setUser(this.formLogin.value.email);
            this.localStorageService.setPassword(this.encriptionService.EncryptData(this.formLogin.value.password));
            
            this.localStorageService.setIsReAuth("true");
            this.authService.queryParams = { };
            this.router.navigate(["/callback"]);
          }
        } 
        else {
          this.isLoading = false;
          this.loginInvalid = true;
          Sentry.captureMessage('LoginPage.Login: isSuccess false', { level: 'warning', extra: { response: res } });
        }
      },
      (err) => {
        if(!environment.production) console.log("Error al loggearse", err);
        // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        this.isLoading = false;
      }
    );
  }

  recoveryPasswordDialog() {
   const dialogRef = this.dialog.open(SendRecoveryPasswordDialogComponent, {
      width: '450px',
      height: '440px',
      data: { name: 'Angular' },
      panelClass: 'dialog-container-custom'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(!environment.production) console.log(`Dialog result: ${result}`);
    });
  }

  togglePasswordVisibility(){
    this.hidePassword = !this.hidePassword;
  }
  
  isLoggedIn(){
    if (this.localStorageService.getToken() != null 
        && this.localStorageService.getToken() != undefined
        && this.localStorageService.getToken() != ""
        && this.localStorageService.getUser() != null 
        && this.localStorageService.getUser() != undefined
        && this.localStorageService.getUser() != ""
        ){
      this.suscription_checkAuth = this.authService.checkAuthenticated().subscribe({
        next: (arg) => {
          if (arg){
            this.router.navigate(["/callback"]);
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al verificar token (en login)', error);
        }
      });
    }
  }
}
